import * as React from 'react';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { Store } from 'redux';
import { History } from 'history';
import { ToastContainer, toast } from 'react-toastify';
import { IntercomProvider } from 'react-use-intercom';
import 'react-toastify/dist/ReactToastify.css';

import { ApplicationState } from './store/types';
import App from './App';
import { LogoutOverlay } from './components/auth/login/LogoutOverlay';
import { Sockets } from './Sockets';
import { SystemNotification } from './components/auth/notifications/SystemNotification';
import { SwitchAccountOverlay } from './components/auth/login/SwitchAccountOverlay';
import { LogoutWarningModal } from './components/shared/modal/LogoutWarningModal';
import styles from './App.module.scss';

const INTERCOM_APP_ID = 'wz2qysk5';

interface MainProps {
    store: Store<ApplicationState>
    history: History
}

const Main: React.FC<MainProps> = ({ store, history }) => (
    <div className={styles.appRoot}>
        <Provider store={store}>
            <Router history={history}>
                <IntercomProvider appId={INTERCOM_APP_ID} key='ark-51-intercom'>
                    <SwitchAccountOverlay />
                    <App />
                    <Sockets />
                    <SystemNotification />
                    <LogoutOverlay />
                    <LogoutWarningModal />
                </IntercomProvider>
            </Router>
            <ToastContainer
                position={toast.POSITION.BOTTOM_LEFT}
                autoClose={4000}
                closeOnClick
                limit={3}
            />
        </Provider>
    </div>
);

export default Main;
